export default __webpack_public_path__ + "static/media/logo.b033e618.png";